// extracted by mini-css-extract-plugin
module.exports = {"container":"_3CGuc","inPostPage":"_2-7Fu","noMargin":"KU4Qj"};